import { render } from "./MySharePage.vue?vue&type=template&id=f9b011b2&scoped=true"
import script from "./MySharePage.vue?vue&type=script&lang=js"
export * from "./MySharePage.vue?vue&type=script&lang=js"

import "./MySharePage.vue?vue&type=style&index=0&id=f9b011b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b011b2"]])

export default __exports__